import { Link, useLocation } from 'react-router-dom'
import { styled } from '@linaria/react'
import { minimalVars as v } from '@ovasabi/ui-minimal/tokens'
import { ChefHatIcon, PlateIcon, StorefrontIcon } from '../../components/icons'

const tabs = [
  { path: '/dishes', label: 'Dishes', icon: PlateIcon },
  { path: '/kitchens', label: 'Kitchens', icon: StorefrontIcon },
  { path: '/menus', label: 'Menus', icon: ChefHatIcon },
] as const

const Style = {
  NavWrap: styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    width: 100%;
    min-height: 48px;
  `,
  Nav: styled.nav`
    display: inline-flex;
    align-items: center;
    gap: 4px;
    padding: 4px;
    border: 1px solid ${v.color.borderSubtle};
    border-radius: ${v.radius.pill};
    background: ${v.color.bgSurfaceAlt};
    box-shadow: inset 0 1px 2px rgba(0, 0, 0, 0.03);
    width: fit-content;
    max-width: 100%;
    overflow-x: auto;
    scrollbar-width: none;

    &::-webkit-scrollbar {
      display: none;
    }
  `,
  Tab: styled(Link)`
    min-height: 38px;
    height: 38px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
    padding: 0 18px;
    border-radius: ${v.radius.pill};
    color: ${v.color.textSecondary};
    font-size: ${v.typography.captionSize};
    font-weight: ${v.typography.weightBold};
    text-decoration: none;
    white-space: nowrap;
    transition:
      background-color 160ms ease,
      color 160ms ease,
      box-shadow 160ms ease,
      transform 120ms ease;

    &[aria-current='page'] {
      background: ${v.color.bgSurface};
      color: ${v.color.brand};
      box-shadow: 0 2px 6px -1px rgba(0, 0, 0, 0.08), 0 1px 2px rgba(0, 0, 0, 0.04);
    }

    &:focus-visible {
      outline: 2px solid ${v.color.borderFocus};
      outline-offset: 2px;
    }

    @media (hover: hover) and (pointer: fine) {
      &:hover:not([aria-current='page']) {
        color: ${v.color.textPrimary};
        background: rgba(255, 255, 255, 0.6);
      }
    }
  `,
}

export const ExploreNavigation = () => {
  const { pathname } = useLocation()
  return (
    <Style.NavWrap>
      <Style.Nav aria-label="Explore dishes, chefs and menus">
        {tabs.map(({ path, label, icon: Icon }) => (
          <Style.Tab
            key={path}
            to={path}
            aria-current={pathname === path || pathname.startsWith(`${path}/`) ? 'page' : undefined}
          >
            <Icon size="sm" />
            {label}
          </Style.Tab>
        ))}
      </Style.Nav>
    </Style.NavWrap>
  )
}
